import { defineStore } from "pinia"
import { Image } from "@/types/Image"
import { Colors } from "@/types/Color"


export const useLayoutStore = defineStore("layout", {
    state: () => (
        {
            app: {
                color: null as unknown | Colors,  // Styling layout color
                theme: ['#192a56', '#fff', '#192a56', '#fff', '#192a56', '#fff', '#fcd34d', '#1f1f1f'] as string[],  // For styling app color
                environment: null as string | null // 'local' | 'staging'
            },
            currentRoute: "grp.dashboard.show", // Define value to avoid route null at first load
            currentParams: {} as {[key: string]: string},
            leftSidebar: {
                show: true,
            },
            rightSidebar: {
                activeUsers: {
                    users: [],
                    count: 0,
                    show: false
                },
            },
            // stackedComponents: [] as StackedComponent[],
            user: {} as { id: number, avatar_thumbnail: Image, email: string, username: string },
        }
    ),

});

